// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__2DP4K","item1":"style_item1__NfDbq","item2":"style_item2__3iCCM","item3":"style_item3__18zt6"};